// extracted by mini-css-extract-plugin
export default {"containerGlobal":"AddEmployee_containerGlobal__bYonL","div":"AddEmployee_div__1nOaO"};